import {formatBytes, DocumentViewer, ProviderDocument, ProviderDocumentUrl, ProviderSendEmail, Spinner} from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { RootStore } from 'stores';
import * as S from './claim-timeline-table.styles';

interface IEmailDetailProps {
    email: ProviderSendEmail;
}

export const EmailDetail: React.FunctionComponent<IEmailDetailProps> = inject('rootStore')(
    observer(
        (props: IEmailDetailProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const { claimStore } = rootStore;
            const {email} = props;
            //const { document } = props;
            const [loading, setLoading] = useState(false);
            // const [documentUrl, setDocumentUrl] = useState<ProviderDocumentUrl | undefined>();

            // useEffect(() => {
            //     (async (): Promise<void> => {
            //         if (document && document.id) {
            //             setLoading(true);
            //             const url = await claimStore.loadDocumentDownloadUrl(document.id, document.documentType);
            //             setLoading(false);
            //             setDocumentUrl(url);
            //         }
            //     })();
            // }, [document, claimStore]);

            return (
                <S.ExpandContainer>
                    <S.ExpandTable>
                        <S.ExpandTBody>
                            {loading && (
                                <S.ExpandTR>
                                    <S.ExpandTD colSpan={2}>
                                        <Spinner />
                                    </S.ExpandTD>
                                </S.ExpandTR>
                            )}
                            {!loading && (
                                <>
                                    <S.ExpandTR>
                                        <S.ExpandTH>From</S.ExpandTH>
                                        <S.ExpandTD>{email.fromEmail}</S.ExpandTD>
                                    </S.ExpandTR>
                                    <S.ExpandTR>
                                        <S.ExpandTH>To</S.ExpandTH>
                                        <S.ExpandTD>{email.toEmail}</S.ExpandTD>
                                    </S.ExpandTR>
                                    <S.ExpandTR>
                                        <S.ExpandTH>Subject</S.ExpandTH>
                                        <S.ExpandTD>{email.subject}</S.ExpandTD>
                                    </S.ExpandTR>
                                </>
                            )}
                        </S.ExpandTBody>
                    </S.ExpandTable>
                </S.ExpandContainer>
            );
        },
    ),
);
